import routes from '@routes';
import { CacheProps, fetchApi } from '../../fetch';

interface SendOrderProps extends CacheProps {
  orderItemId: string
  uploadReceipt: any
}

const storeCardToCardReceiptApi = ({ orderItemId, uploadReceipt, ...rest }: SendOrderProps) => {
  return fetchApi({
    method: 'POST',
    URL: routes['api.order.store-card-to-card-receipt'],
    payload: {
      id: orderItemId,
      upload_receipt: uploadReceipt,
    },
    withToken: true,
    ...rest,
  });
};

export default storeCardToCardReceiptApi;
